import { getLocalizedString } from '@grandvisionhq/utils';

const mapAppliedDiscounts = (appliedDiscounts, intl)=>{
    const mappedDiscounts = appliedDiscounts === null || appliedDiscounts === void 0 ? void 0 : appliedDiscounts.map((discount)=>{
        var ref;
        return {
            label: getLocalizedString((ref = discount.details) === null || ref === void 0 ? void 0 : ref.name, intl.locale),
            value: discount.amount,
            type: discount.type
        };
    });
    return mappedDiscounts;
};

export { mapAppliedDiscounts };
//# sourceMappingURL=map-applied-discounts.js.map
